/**
 * @module ui/lazy-bg-images
 * @description Add simple support for lazy-sizes background images.
 * This module should be initialized before lazy-sizes.
 */
export default function init() {
  document.addEventListener("lazybeforeunveil", (e) => {
    const bg = e.target.getAttribute("data-bg");
    if (bg) {
      e.target.style.backgroundImage = `url("${bg}")`;
    }
  });
}
